/* cbdv: the free-shipping bar of the cart page and the cart drawer (snippets/free-shipping-bar.liquid).

   It is a custom element on purpose. Dawn redraws the drawer with innerHTML after every change, and
   scripts inside innerHTML never run, so a bar set up by an inline script stayed empty in the drawer.
   A custom element is set up by the browser each time it is inserted (connectedCallback), wherever
   that happens. The amounts come from data attributes (theme settings CBDV → Spedizione), the words
   from window.freeShippingStrings (snippets/cbdv-head.liquid). The total is read from /cart.js:
   it is the total after discounts, like Shopify's free-shipping rate. */

class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.messageEl = this.querySelector('[data-shipping-message]');
    this.progressEl = this.querySelector('[data-shipping-progress]');
    this.update();
    // Dawn publishes 'cart-update' after a change; the drawer also redraws, which sets up a new bar.
    this.unsubscribe = typeof subscribe === 'function' ? subscribe('cart-update', () => this.update()) : null;
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  isItaly() {
    const select = document.querySelector('localization-form select[name="country_code"]');
    const country = (select && select.value) || (window.Shopify && window.Shopify.country) || 'IT';
    return country === 'IT';
  }

  threshold() {
    return Number(this.isItaly() ? this.dataset.thresholdIt : this.dataset.thresholdOther);
  }

  formatMoney(cents) {
    return `€${(cents / 100).toFixed(2)}`.replace('.', ',');
  }

  async update() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      const threshold = this.threshold();
      const remaining = threshold - cart.total_price;
      const strings = window.freeShippingStrings;

      this.progressEl.setAttribute(
        'style',
        `width: ${Math.min((cart.total_price / threshold) * 100, 100)}%; background-color: #28a745; height: 100%; ` +
          'position: absolute; top: 0; left: 0; border-radius: 4px; transition: width 0.5s ease; display: block;'
      );

      if (remaining > 0) {
        const amount = `<strong>${this.formatMoney(remaining)}</strong>`;
        this.messageEl.innerHTML = (this.isItaly() ? strings.messageItaly : strings.messageOther).replace('[amount]', amount);
        this.messageEl.classList.remove('free-shipping-bar__message--success');
      } else {
        this.messageEl.innerHTML = strings.success;
        this.messageEl.classList.add('free-shipping-bar__message--success');
      }
    } catch (error) {
      console.error('Error updating free shipping bar:', error);
    }
  }
}

if (!customElements.get('free-shipping-bar')) customElements.define('free-shipping-bar', FreeShippingBar);
